import { Text } from '@mnd-frontend/ui/publish/components';
import { SPACING_1 } from '@mnd-frontend/ui/shared/tokens';
import type React from 'react';
import type { FC } from 'react';
import styled, { css } from 'styled-components';

type Props = {
  disabled?: boolean;
  icon: React.ReactNode;
  caption: string;
  smallCaption?: boolean;
};

const IconWrapper = styled.div<{ $disabled?: boolean }>`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  pointer-events: none;
  position: absolute;
  top: 0;

  p {
    margin-top: ${SPACING_1};
    max-width: 50%;
    word-break: break-word;
    text-align: center;
  }

  ${({ $disabled }) =>
    $disabled &&
    css`
      p,
      svg {
        opacity: 0.7;
      }
      pointer-events: none;
    `}
`;

const IconAndCaption: FC<Props> = ({ icon, caption, disabled, smallCaption }) => (
  <IconWrapper $disabled={disabled}>
    {icon}
    <Text as="p" variant={smallCaption ? 'labelExtraSmall' : 'body'}>
      {caption}
    </Text>
  </IconWrapper>
);

export default IconAndCaption;
